"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  htmlFontSize: 16,
  fontSize: 14,
  fontSize8: '0.5rem',
  fontSize10: '0.625rem',
  fontSize11: '0.6875rem',
  fontSize12: '0.75rem',
  fontSize13: '0.8125rem',
  fontSize14: '0.875rem',
  fontSize15: '0.9375rem',
  fontSize16: '1rem',
  fontSize18: '1.125rem',
  fontSize20: '1.25rem',
  fontSize22: '1.375rem',
  fontSize24: '1.5rem',
  fontSize26: '1.62rem',
  fontSize28: '1.75rem',
  fontSize30: '1.875rem',
  fontSize32: '2rem',
  fontSize38: '2.375rem',
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  subtitle1: {
    fontFamily: 'inherit',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.5em',
    color: '#333333'
  },
  subtitle2: {
    fontFamily: 'inherit',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    letterSpacing: '0.00714em'
  },
  body1: {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.46429em',
    color: '#333333'
  },
  body2: {
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.71429em',
    color: '#333333'
  },
  caption: {
    fontFamily: 'inherit',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.375em',
    color: '#97a1a6'
  },
  overline: {
    fontFamily: 'inherit',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 2.66,
    letterSpacing: '0.08333em',
    textTransform: 'uppercase'
  }
};